import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const stripDisplay = (s) => {
  const { displayStart, displayEnd, ...rest } = s;
  void displayStart;
  void displayEnd;
  return rest;
};

const iso = (d) => {
  const y = d.getFullYear();
  const m = (d.getMonth() + 1).toString().padStart(2, '0');
  const day = d.getDate().toString().padStart(2, '0');
  return `${y}-${m}-${day}`;
};
const defaultEnd = () => iso(new Date());
const defaultStart = () => iso(new Date(Date.now() - 30 * 24 * 60 * 60 * 1000));

const STATUSES = ['Active', 'Cancelled', 'Expired', 'On Hold', 'Other'];
const PLATFORMS = [
  { value: 1, label: 'Android' },
  { value: 2, label: 'iOS' },
];

const defaultState = () => ({
  startDate: defaultStart(),
  endDate: defaultEnd(),
  displayStart: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000),
  displayEnd: new Date(),
  platform: [],
  status: ['Active', 'Cancelled', 'Expired'],
  eventTypes: [],
});

const FilterBar = ({ onApply = () => {} }) => {
  const [state, setState] = useState(defaultState());
  const [error, setError] = useState('');

  const toggleStatus = (s) => {
    setState((prev) => ({
      ...prev,
      status: prev.status.includes(s)
        ? prev.status.filter((x) => x !== s)
        : [...prev.status, s],
    }));
  };

  const togglePlatform = (p) => {
    setState((prev) => ({
      ...prev,
      platform: prev.platform.includes(p)
        ? prev.platform.filter((x) => x !== p)
        : [...prev.platform, p],
    }));
  };

  const handleFromDate = (date) => {
    setState((p) => ({ ...p, displayStart: date, startDate: date ? iso(date) : '' }));
  };
  const handleToDate = (date) => {
    setState((p) => ({ ...p, displayEnd: date, endDate: date ? iso(date) : '' }));
  };

  const apply = () => {
    if (state.startDate && state.endDate && state.startDate > state.endDate) {
      setError('Start date must be <= end date');
      return;
    }
    setError('');
    onApply(stripDisplay(state));
  };

  const clear = () => {
    const d = defaultState();
    setState(d);
    setError('');
    onApply(stripDisplay(d));
  };

  return (
    <div className="wa-filter-card">
      <div className="wa-filter-row wa-filter-row--dates">
        <div className="wa-filter-field">
          <label htmlFor="wa-from" className="wa-filter-field-label">From</label>
          <DatePicker
            selected={state.displayStart}
            onChange={handleFromDate}
            dateFormat="dd/MM/yyyy"
            placeholderText="From Date"
            className="wa-datepicker"
            id="wa-from"
          />
        </div>
        <div className="wa-filter-field">
          <label htmlFor="wa-to" className="wa-filter-field-label">To</label>
          <DatePicker
            selected={state.displayEnd}
            onChange={handleToDate}
            dateFormat="dd/MM/yyyy"
            placeholderText="To Date"
            className="wa-datepicker"
            id="wa-to"
          />
        </div>
        <div className="wa-filter-actions">
          <button type="button" className="wa-btn wa-btn--primary" onClick={apply}>Search</button>
          <button type="button" className="wa-btn wa-btn--ghost" onClick={clear}>Clear</button>
        </div>
      </div>

      <div className="wa-filter-row">
        <div className="wa-pill-group">
          <span className="wa-pill-group-label">Platform</span>
          {PLATFORMS.map((p) => {
            const active = state.platform.includes(p.value);
            return (
              <button
                key={p.value}
                type="button"
                className={`wa-pill${active ? ' wa-pill--active' : ''}`}
                aria-pressed={active}
                aria-label={p.label}
                onClick={() => togglePlatform(p.value)}
              >
                {p.label}
              </button>
            );
          })}
        </div>
        <div className="wa-pill-group">
          <span className="wa-pill-group-label">Status</span>
          {STATUSES.map((s) => {
            const active = state.status.includes(s);
            return (
              <button
                key={s}
                type="button"
                className={`wa-pill${active ? ' wa-pill--active' : ''}`}
                aria-pressed={active}
                aria-label={s}
                onClick={() => toggleStatus(s)}
              >
                {s}
              </button>
            );
          })}
        </div>
      </div>

      {error && (
        <p role="alert" className="wa-filter-error">{error}</p>
      )}
    </div>
  );
};

FilterBar.propTypes = {
  onApply: PropTypes.func,
};

export default FilterBar;
